<template>
  <div id="app" class="flexContainer fullContainer">
    <div class="sidePanelOuterContainer">
      <NavigationPanel></NavigationPanel>
    </div>
    <div
      style="position: absolute; background-color: Transparent"
      class="flexContainer fullContainer"
      v-if="showPopup"
    >
      <span id="popUpBackground"></span>
      <Popup
        id="popUpOuterContainer"
        :popupType="popupType"
        :popupData="popupData"
      ></Popup>
    </div>
    <div class="contentOuterContainer">
      <router-view></router-view>
    </div>
    <div
      id="policyLinkContainer"
      class="flexContainer yEndContainer sidePanelOuterContainer"
    >
      <a
        style="padding-bottom: 5%; font-size: 0.4em; color: black"
        :href="policyUrl"
        target="_blank"
        >Nasz regulamin</a
      >
    </div>
  </div>
</template>

<script>
import Popup from "./components/popups/popup";
import NavigationPanel from "./components/navigationPanel";

export default {
  data() {
    return {
      policyUrl:
        process.env.VUE_APP_STATIC_HOST + "/static/docs/privacy-policy.pdf",
    };
  },
  computed: {
    showPopup() {
      return this.$store.getters.popupContext.isNewToShow;
    },
    popupType() {
      return this.$store.getters.popupContext.type;
    },
    popupData() {
      return this.$store.getters.popupContext.data;
    }
  },
  components: {
    Popup,
    NavigationPanel,
  },
};
</script>

<style>
@font-face {
  font-family: "Asap Medium";
  src: local("Asap-Medium"),
    url("./assets/fonts/Asap-Medium.ttf") format("truetype"),
    url("./assets/fonts/Asap-Medium.woff") format("woff"),
    url("./assets/fonts/Asap-Medium.woff2") format("woff2");
}

@font-face {
  font-family: "Calistoga Regular";
  src: local("Calistoga-Regular"),
    url("./assets/fonts/Calistoga-Regular.ttf") format("truetype"),
    url("./assets/fonts/Calistoga-Regular.woff") format("woff"),
    url("./assets/fonts/Calistoga-Regular.woff2") format("woff2");
}

::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 0 rgba(0, 0, 0, 0.3);
  background-color: #ffffff;
}

::-webkit-scrollbar {
  width: 0;
  background-color: #ffffff;
}

::-webkit-scrollbar-thumb {
  background-color: #000000;
}

html {
  overflow: hidden;
  font-family: "Asap Medium", sans-serif;
  font-size: calc(1em + 1vw);
  width: 100%;
  height: 100%;
}

body {
  width: 100%;
  height: 100%;
  padding: 0;
  border: 0;
  margin: 0;
  background-color: #ffffff;
}

a {
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

.flexContainer {
  display: flex;
}

.columnContainer {
  flex-direction: column;
}

.xCenterContainer {
  justify-content: center;
}

.yCenterContainer {
  align-items: center;
}

.centerContainer {
  justify-content: center;
  align-items: center;
}

.yEndContainer {
  align-items: flex-end;
}

.fullContainer {
  height: 100%;
  width: 100%;
}

.linkAlike {
  background: none;
  border: none;
  padding: 0;
  text-decoration: underline;
  cursor: pointer;
}

.closeButton {
  align-self: flex-end;
  background-color: Transparent;
  padding: 0 1% 0 0;
  margin: 0;
  border: 0;
  color: #ffffff;
  font-size: 18px;
  cursor: pointer;
}

.sidePanelOuterContainer {
  width: 25%;
}

.contentOuterContainer {
  width: 50%;
}

#policyLinkContainer {
  justify-content: center;
}

#popUpBackground {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  opacity: 0.8;
  z-index: 1;
}

#popUpOuterContainer {
  z-index: 2;
}

@media (max-width: 1000px) {
  body {
    width: 96%;
    height: 98%;
    padding: 2%;
  }

  #app {
    flex-direction: column;
  }

  .sidePanelOuterContainer {
    width: 100%;
    height: 20%;
  }

  .contentOuterContainer {
    width: 100%;
    height: 70%;
  }

  #policyLinkContainer {
    justify-content: flex-end;
    height: 10%;
  }
}
</style>
